import styles from './ImagePopUp.module.less';

export default function ImagePopUp(imgUrl) {
  const popUpContainer = document.createElement('div');
  popUpContainer.className = styles.popUpContainer;

  const popUpContent = document.createElement('div');
  popUpContent.className = styles.popUpContent;

  const img = document.createElement('img');
  img.src = imgUrl;
  img.className = styles.image;

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = styles.closeButton;
  closeButton.innerHTML = '&times;';

  closeButton.addEventListener('click', () => {
    document.body.removeChild(popUpContainer);
  });

  popUpContent.appendChild(closeButton);
  popUpContent.appendChild(img);
  popUpContainer.appendChild(popUpContent);
  document.body.appendChild(popUpContainer);
}
